var $f44b7cf39ac8f315$exports = {};
$f44b7cf39ac8f315$exports = {
  "colorInputLabel": function colorInputLabel(args) {
    return "".concat(args.label, ", ").concat(args.channelLabel);
  },
  "colorNameAndValue": function colorNameAndValue(args) {
    return "".concat(args.name, ": ").concat(args.value);
  },
  "colorPicker": "Izbirnik barv",
  "colorSwatch": "barvna paleta",
  "transparent": "prozorno",
  "twoDimensionalSlider": "2D drsnik"
};
export { $f44b7cf39ac8f315$exports as default };